"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateErrorList = exports.nativeErrorsList = exports.SB_WEB_SOCKET_ERROR_DEFAULT_MESSAGE = exports.SB_HTTP_ERROR_DEFAULT_MESSAGE = exports.SB_API_ERROR_DEFAULT_MESSAGE = exports.SB_ERROR_DEFAULT_MESSAGE = exports.SB_WEB_SOCKET_ERROR = exports.SB_NATIVEJS_ERROR = exports.SB_API_ERROR = exports.SB_HTTP_ERROR = exports.SB_ERROR = exports.DEFAULT = void 0;

var _messagesI18n = require("./messages-i18n");

// Default handleError() handler. It behaves like `default` option
// in the switch statement. Example:
// .catch(error => handleError(error, {
//   [DEFAULT]: (error) => {}, // will be called on default
// }))
var DEFAULT = 'default'; // Error types

exports.DEFAULT = DEFAULT;
var SB_ERROR = 'SbError';
exports.SB_ERROR = SB_ERROR;
var SB_HTTP_ERROR = 'SbHttpError';
exports.SB_HTTP_ERROR = SB_HTTP_ERROR;
var SB_API_ERROR = 'SbApiError';
exports.SB_API_ERROR = SB_API_ERROR;
var SB_NATIVEJS_ERROR = 'SbNativeJSError';
exports.SB_NATIVEJS_ERROR = SB_NATIVEJS_ERROR;
var SB_WEB_SOCKET_ERROR = 'SbWebSocketError'; // Default messages for individual error types

exports.SB_WEB_SOCKET_ERROR = SB_WEB_SOCKET_ERROR;
var SB_ERROR_DEFAULT_MESSAGE = _messagesI18n.messages.anUnexpectedErrorHasOccurred.id;
exports.SB_ERROR_DEFAULT_MESSAGE = SB_ERROR_DEFAULT_MESSAGE;
var SB_API_ERROR_DEFAULT_MESSAGE = _messagesI18n.messages.anUnexpectedApiErrorHasOccurred.id;
exports.SB_API_ERROR_DEFAULT_MESSAGE = SB_API_ERROR_DEFAULT_MESSAGE;
var SB_HTTP_ERROR_DEFAULT_MESSAGE = _messagesI18n.messages.anUnexpectedHttpErrorHasOccurred.id;
exports.SB_HTTP_ERROR_DEFAULT_MESSAGE = SB_HTTP_ERROR_DEFAULT_MESSAGE;
var SB_WEB_SOCKET_ERROR_DEFAULT_MESSAGE = _messagesI18n.messages.anUnexpectedWebsocketErrorHasOccurred.id; // List of native JS errors, which will be caught by SB_NATIVEJS_ERROR
// Don't include Error in the list since utils.isInstanceOf will produce
// inconsistent behaviour

exports.SB_WEB_SOCKET_ERROR_DEFAULT_MESSAGE = SB_WEB_SOCKET_ERROR_DEFAULT_MESSAGE;
var nativeErrorsList = ['EvalError', 'RangeError', 'ReferenceError', 'SyntaxError', // 'TypeError', // removed because of custom handling for TypeError
'URIError'];
exports.nativeErrorsList = nativeErrorsList;
var translateErrorList = {
  'Failed to fetch': _messagesI18n.messages.networkErrorOccurred
};
exports.translateErrorList = translateErrorList;
//# sourceMappingURL=constants.js.map